module.exports = __webpack_public_path__ + "img/scan-icon.5fc8cb15.svg";